<template>
  <div class="video-upload">
    <el-upload
        class="upload-demo"
        :class="videoList.length > 0 ? 'no-click' : ''"
        :action="baseURL + '/upload'"
        :headers="{token: token}"
        accept=".mp4"
        :before-upload="beforeUpload"
        :on-remove="deleteVideo"
        :on-change="uploadVideo"
        :limit="1"
        drag
        :file-list="videoList">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">点击上传</div>
      <div slot="tip" class="el-upload__tip"> 只能上传单个视频，格式为：mp4，大小不超过20MB，建议视频时长在15秒内</div>
    </el-upload>
    <div class="play-btn" >
      <el-button @click="playVideo(item.url)" type="primary" size="mini"  v-for="item in videoList" :key="item.url">播放</el-button>
    </div>
    <el-dialog class="video-dialog" :visible.sync="visible" width="600px" @close="closeVideo">
      <video
          :src="videoSrc"
          controls
          class="video-box"
          ref="video">
      </video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    // 已有图片
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  name: 'videoUpload',
  data () {
    return {
      baseURL: this.baseUrl,
      token: localStorage.getItem('token'),
      videoList: this.list,
      videoSrc: '',
      visible: false
    }
  },
  watch: {
    list (newV) {
      console.log(newV)
      this.videoList = newV
    }
  },
  methods: {
    uploadVideo (file) {
      if (file.response && file.response.code === '200') {
        this.$message.success('上传成功')
        this.videoList.push({name: file.response.msg, url: file.response.msg})
        this.$emit('success', this.videoList)
      }
    },
    // 上传图片之前的操作
    beforeUpload (file) {
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isLt20M) {
        this.$message.error('上传视频大小不能超过 20MB!')
      }
      return isLt20M
    },
    // 删除视频
    deleteVideo (file) {
      if (file.status === 'success') {
        this.videoList.forEach((item, index) => {
          if (item.url === file.url) {
            this.videoList.splice(index, 1)
            this.$emit('success', this.videoList)
          }
        })
      }
    },
    // 播放视频
    playVideo (url) {
      this.visible = true
      this.videoSrc = url
    },
    closeVideo () {
      this.videoSrc = ''
    }
  }
}
</script>

<style scoped lang="less">
.video-upload {
  width: calc(100% - 56px);
}
.play-btn {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
}
.video-box {
  width: 100%;
  height: 300px;
}

</style>
<style lang="less">
.video-dialog {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0!important;
    background-color: #000;
  }
}
.no-click .el-upload--text {
  cursor: not-allowed;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/videoUpload.vue